// removed by extract-text-webpack-plugin
module.exports = {"lastDeliveriesWrap":"qempo_LastDeliveriesWrap_lastDeliveriesWrap-JC8Thks","lastDeliveriesContent":"qempo_LastDeliveriesWrap_lastDeliveriesContent-2gHdzE2","lastDeliveryWrap":"qempo_LastDeliveriesWrap_lastDeliveryWrap-1MiiROr","namesWrap":"qempo_LastDeliveriesWrap_namesWrap-2rOMbEe","pill":"qempo_LastDeliveriesWrap_pill-f7BT3Rx","traveler":"qempo_LastDeliveriesWrap_traveler-3VLndTF","buyer":"qempo_LastDeliveriesWrap_buyer-11xgI03"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/flight-landing/components/LastDeliveries/LastDeliveriesWrap.scss
// module id = 1732
// module chunks = 0